import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import { PropertyAndLoanTestIds } from 'app/pages/loanApplication/tabs/propertyAndLoan/PropertyAndLoan.testIds';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { formatCurrencyValue } from 'utils/format';

import {
  amountCellStyles,
  emptyRowStyles,
  getBodyRowStyles,
  headerRowStyles,
  tableWrapperStyles,
  totalRowStyles,
} from './AppraisalSurchargesTable.styles';

const AppraisalSurchargesTable = ({ surcharges }) => {
  const totalAmount = useMemo(
    () => surcharges.reduce((sum, { amount }) => sum + (amount ?? 0), 0),
    [surcharges],
  );

  const hasSurcharges = !_.isEmpty(surcharges);

  return (
    <Box
      data-testid={PropertyAndLoanTestIds.APPRAISAL_FORM_APPRAISAL_SURCHARGES_TABLE}
      sx={tableWrapperStyles}
    >
      <Box sx={headerRowStyles}>
        <Typography color="text.dark" component="p" variant="bold12">
          Name
        </Typography>
        <Typography color="text.dark" component="p" sx={amountCellStyles} variant="bold12">
          Amount
        </Typography>
      </Box>
      {!hasSurcharges && (
        <Box sx={emptyRowStyles}>
          <Typography color="text.dark" component="p" variant="regularItalic12">
            No surcharges applied
          </Typography>
        </Box>
      )}
      {hasSurcharges &&
        surcharges.map(({ id, name, amount }, index) => (
          <Box key={id} sx={getBodyRowStyles({ isLastRow: index === surcharges.length - 1 })}>
            <Typography color="text.primary" component="p" variant="regular14">
              {name}
            </Typography>
            <Typography
              color="text.primary"
              component="p"
              sx={amountCellStyles}
              variant="regular14"
            >
              {formatCurrencyValue(amount)}
            </Typography>
          </Box>
        ))}
      {hasSurcharges && (
        <Box
          data-testid={PropertyAndLoanTestIds.APPRAISAL_FORM_APPRAISAL_SURCHARGES_TABLE_TOTAL}
          sx={totalRowStyles}
        >
          <Typography color="text.dark" component="p" variant="bold12">
            Total
          </Typography>
          <Typography color="text.dark" component="p" sx={amountCellStyles} variant="bold12">
            {formatCurrencyValue(totalAmount)}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

AppraisalSurchargesTable.propTypes = {
  surcharges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      amount: PropTypes.number,
    }),
  ).isRequired,
};

export default memo(AppraisalSurchargesTable);
